var enums = Object.create(null);

enums.TYPE_SCORE = {
  GENERAL: 'GENERAL',
  FINAL: 'FINAL',
  RX: 'RX',
  INTERMEDIATE: 'INTERMEDIATE',
  SCALED: 'SCALED'
};

enums.TYPE_SCORE_LABELS = {
  RX: 'RX',
  INTERMEDIATE: 'Intermediate',
  SCALED: 'Scaled'
};

enums.STATUS = {
  REGISTER: 'register',
  COMING_SOON: 'coming_soon',
  SOLD_OUT: 'sold_out',
  CLOSED: 'closed',
  LIVE: 'live'
};

enums.TYPE = {
  ARENA: 'Arena',
  GYMNASE: 'Gymnase',
  BOX: 'Box',
  OUTDOOR: 'Outdoor'
};

enums.LEVEL = {
  RX: 'RX',
  SCALED: 'Scaled',
  BEGINNER: 'Biginner',
  UNDEFINED: 'Undefined'
};

enums.SPORT_TYPE = {
  FUNCTIONAL_FITNESS: 'Functional Fitness',
  HYBRID_RACE: 'Hybrid race',
  TRAIL: 'Trail'
};

enums.SPORT_TYPE_COLOR = {
  FUNCTIONAL_FITNESS: '#C23B2C',
  HYBRID_RACE: '#C46A0F',
  TRAIL: '#1F6B41'
};

enums.REGISTRATION_STATUS = {
  COMPLETED: 'Complété',
  NONE_COMPLETED: 'Incomplet',
  WAITING_LIST: `En liste d'attente`,
  DELETED: 'Supprimé',
};

module.exports = enums;
